/**
 * The article the editor may open — the one the server sent, body and all,
 * or nothing.
 *
 * LB3T5-BF-02. WikiEditor's save always PUTs `content`, so an editor opened
 * on an article without its body overwrites the stored body with an empty
 * one on the first save (BUG-687 again). The `?edit=<id>` deep link used to
 * open the editor on the row it found in a list it had loaded (which carries
 * no body) and, when GET /wiki/articles/:id failed, fell back to exactly that
 * row. Now the editor opens only on a body the server sent; with none, this
 * answers null and the caller says so and stays out of edit mode.
 *
 * Library LB6-T2 (L6-16): the editor is opened from GET /wiki/articles/:id
 * ALONE — no list is consulted, so an article past the first page of any
 * list opens like any other ("Article not found in this folder" past the
 * 50th is gone).
 */
import type { KBArticle } from '@/components/kb/WikiEditor';
import type { WikiArticleDetail } from '@/types/library';

export function articleForEditor(
  detail: WikiArticleDetail | null | undefined,
): KBArticle | null {
  if (!detail || typeof detail.content !== 'string') return null;
  return {
    id: detail.id,
    title: detail.title,
    content: detail.content,
    status: detail.status,
    folderId: detail.folderId,
    parentId: detail.parentId ?? null,
    // The editor keeps tag ids; the article carries tag objects.
    tags: (detail.tags ?? []).map((t) => t.id),
    authorName: detail.authorName ?? 'Unknown',
    viewCount: detail.viewCount ?? 0,
    version: detail.version ?? 1,
    createdAt: detail.createdAt,
    updatedAt: detail.updatedAt ?? detail.createdAt,
    publishedAt: detail.publishedAt,
  };
}
